module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4Ij4KICAgIDxwYXRoIGZpbGw9IiM4ODhCOTQiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTkgMEM0LjAzNyAwIDAgNC4wMzcgMCA5czQuMDM3IDkgOSA5IDktNC4wMzcgOS05LTQuMDM3LTktOS05em0wIDE2Yy0zLjg1OSAwLTctMy4xNDEtNy03czMuMTQxLTcgNy03IDcgMy4xNDEgNyA3LTMuMTQxIDctNyA3em0xLTcuNDE0VjZhMSAxIDAgMSAwLTIgMHYzYzAgLjI2Ni4xMDUuNTE5LjI5My43MDdsMiAyYS45OTcuOTk3IDAgMCAwIDEuNDE0IDAgLjk5OS45OTkgMCAwIDAgMC0xLjQxNEwxMCA4LjU4NnoiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/clock.svg
// module id = 4/yx
// module chunks = 0 170 171 172